// Research tree: fund projects that grant permanent zoo-wide bonuses.
import { store, pushNews } from '../core/store.js';
import { bus } from '../core/bus.js';

export const RESEARCH = {
  nutrition:  { label: 'Advanced Nutrition',  price: 12000, days: 12, effect: 'Animal wellbeing +8',            requires: null },
  enrichment: { label: 'Habitat Enrichment',  price: 18000, days: 16, effect: 'Guests enjoy animals +50% more', requires: 'nutrition' },
  breeding:   { label: 'Breeding Program',    price: 25000, days: 20, effect: 'Reproduction chance doubled',    requires: 'nutrition' },
  retail:     { label: 'Retail Science',      price: 15000, days: 14, effect: 'Amenity income +30%',            requires: null },
};

export class ResearchSystem {
  constructor() {
    this.completed = new Set();
    this.active = null;            // { key, daysLeft }
    this._subs = [
      bus.on('research:start', (key) => this.start(key)),
      bus.on('sim:newDay', () => this.dailyTick()),
    ];
  }
  dispose() { this._subs.forEach((u) => u()); }

  start(key) {
    const def = RESEARCH[key];
    if (!def || this.completed.has(key) || this.active) return;
    if (def.requires && !this.completed.has(def.requires)) {
      bus.emit('ui:toast', { text: `Requires ${RESEARCH[def.requires].label} first.`, kind: 'error' });
      return;
    }
    const s = store.get();
    if (s.money < def.price) { bus.emit('ui:toast', { text: 'Not enough cash!', kind: 'error' }); return; }
    store.set({ money: s.money - def.price });
    this.active = { key, daysLeft: def.days };
    this._sync();
    pushNews(`Research started: ${def.label}.`, 'info');
  }

  dailyTick() {
    if (!this.active) return;
    this.active.daysLeft--;
    if (this.active.daysLeft <= 0) {
      this.completed.add(this.active.key);
      pushNews(`Research complete: ${RESEARCH[this.active.key].label}! ${RESEARCH[this.active.key].effect}.`, 'success');
      store.set({ prestige: store.get().prestige + 5 });
      this.active = null;
    }
    this._sync();
  }

  _sync() {
    store.set({
      researchActive: this.active ? { ...this.active } : null,
      researchDone: [...this.completed],
    });
  }

  // bonuses
  wellbeingBonus() { return this.completed.has('nutrition') ? 8 : 0; }
  viewingMultiplier() { return this.completed.has('enrichment') ? 1.5 : 1; }
  fertilityMultiplier() { return this.completed.has('breeding') ? 2 : 1; }
  incomeMultiplier() { return this.completed.has('retail') ? 1.3 : 1; }
}
